import { createAuthClient } from "better-auth/react";

// Shared auth client for the whole frontend
export const auth = createAuthClient({
  baseURL: process.env.VITE_BACKEND_URL,
  fetchOptions: {
    credentials: "include",
  },
});